import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import { createNewPatient } from "../../services/api";
import Alert from "../../assets/images/alert.png";
import "../SignupPages/SignupCommon.css";
import CustomStepper from "./Stepper";

const NewSignupPage7: React.FC = () => {
  const [firstName, setFirstName] = useState<string>("");
  const [uuidValue, setUuidValue] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState<string>("");
  const [phoneError, setPhoneError] = useState<string>("");
  const navigate = useNavigate();
  const [err, setErr] = useState<string>("");
  const isNewFunnelVariant = localStorage.getItem("isNewFunnelVariant") === "true";
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  });
  useEffect(() => {
    setUuidValue(uuidValue);
  }, [uuidValue]);

  const location = useLocation();

const safeNavigate = (path: string) => {
  if (location.pathname !== path) {
    navigate(path, { replace: true });
  }
};
useEffect(() => {
  const step6Completed = localStorage.getItem("step-6-completed");
  if (step6Completed) {
    safeNavigate("/getting-started/step-7");
  } else {
    safeNavigate("/getting-started/step-6");
  }
}, []);


  const handleNext = async () => {
    if (!isValidEmail(email)) {
      setEmailError(
        "Invalid email address. Please enter a valid email address."
      );
      return;
    } else {
      setEmailError("");
    }

    const cleanedPhone = phone.replace(/\D/g, "");
    if (!isValidPhone(cleanedPhone)) {
      setPhoneError(
        "Invalid phone number. Please enter a 10-digit phone number."
      );
      return;
    } else {
      setPhoneError("");
    }

    if (firstName && lastName && email && phone && state) {
      localStorage.setItem(
        "firstName",
        JSON.stringify({ key: "firstName", value: firstName })
      );
      localStorage.setItem(
        "lastName",
        JSON.stringify({ key: "lastName", value: lastName })
      );
      localStorage.setItem(
        "email",
        JSON.stringify({ key: "email", value: email })
      );
      localStorage.setItem(
        "phone",
        JSON.stringify({ key: "phone", value: phone })
      );
      localStorage.setItem(
        "state",
        JSON.stringify({ key: "state", value: state })
      );
      localStorage.setItem(
        "isSubscribed",
        JSON.stringify({ key: "isSubscribed", value: isSubscribed })
      );
      localStorage.setItem(
        "fullName",
        JSON.stringify({ key: "firstName", value: firstName + " " + lastName })
      );

      try {
        setLoading(true);
        const productCategory = "GLP1"; 
  
        const appointmentResponse = await createNewPatient(
          firstName,
          lastName,
          email,
          phone,
          isSubscribed,
          productCategory,
          uuidValue
        );
  
        const data = await appointmentResponse.json();
  
        if (!appointmentResponse.ok) {
          setErr(data?.error || "Failed to create patient.");
          throw new Error(data?.error || "Failed to create patient.");
        }
  
     
        if (data && data.user && data.user.length > 0) {
          const patientData = data.user[0]; 
          const disableAddress = data.disable_address || false; 
  
          localStorage.setItem(
            "disable_address",
            JSON.stringify({ key: "disable_address", value: disableAddress })
          );
  
          console.log(patientData, "patientData");
  
         
          if (patientData.addressLineOne)
            localStorage.setItem(
              "addressLine1",
              JSON.stringify({
                key: "addressLine1",
                value: patientData.addressLineOne,
              })
            );
          if (patientData.addressLineTwo)
            localStorage.setItem(
              "addressLine2",
              JSON.stringify({
                key: "addressLine2",
                value: patientData.addressLineTwo,
              })
            );
          if (patientData.city)
            localStorage.setItem(
              "city",
              JSON.stringify({ key: "city", value: patientData.city })
            );
          if (patientData.state)
            localStorage.setItem(
              "state",
              JSON.stringify({ key: "state", value: patientData.state })
            );
          if (patientData.zipCode)
            localStorage.setItem(
              "zip",
              JSON.stringify({ key: "zip", value: patientData.zipCode })
            );
  
      
          if (
            patientData.state 
          ) {
            localStorage.setItem(
              "state",
              JSON.stringify({
                key: "state",
                value:
                  patientData.state,
              })
            );
          }
        } else {
  
          localStorage.setItem(
            "disable_address",
            JSON.stringify({ key: "disable_address", value: false })
          );
        }

        localStorage.setItem("step-7-completed", "true");
        if(isNewFunnelVariant){
          navigate("/getting-started/step-9");
        }else{
        navigate("/getting-started/step-8");
      }
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErr(error.message);
        } else {
          setErr("An unexpected error occurred.");
        }
        console.error("Error adding patient:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    const savedFirstName = localStorage.getItem("firstName");
    const savedLastName = localStorage.getItem("lastName");
    const savedEmail = localStorage.getItem("email");
    const savedPhone = localStorage.getItem("phone");
    const savedState = localStorage.getItem("state");
    const savedIsSubscribed = localStorage.getItem("isSubscribed");

    if (savedFirstName) {
      const parsedFirstName = JSON.parse(savedFirstName);
      setFirstName(parsedFirstName.value);
    }
    if (savedLastName) {
      const parsedLastName = JSON.parse(savedLastName);
      setLastName(parsedLastName.value);
    }
    if (savedEmail) {
      const parsedEmail = JSON.parse(savedEmail);
      setEmail(parsedEmail.value);
    }
    if (savedPhone) {
      const parsedPhone = JSON.parse(savedPhone);
      setPhone(parsedPhone.value);
    }
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      setState(parsedState.value);
    }
    if (savedIsSubscribed) {
      const parsedIsSubscribed = JSON.parse(savedIsSubscribed);
      setIsSubscribed(parsedIsSubscribed.value);
    }
  }, []);
  const isValidEmail = (email: string): boolean => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const isValidPhone = (phone: string): boolean => {
    const phonePattern = /^\d{10}$/;
    return phonePattern.test(phone);
  };

  const styles = {
    container: {
      width: "48%",
      gap: "20px",
      margin: "0 auto",
    },
    content: {
      marginTop: "20px",
    },
    label: {
      marginBottom: "10px",
      fontWeight: "bold",
    },
    inputContainer: {
      width: "100%",
      marginBottom: "20px",
    },
    input: {
      width: "48%",
      height: "52px",
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #96c6da",
      borderRadius: "154px",
      background: "#FFF",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "20px",
    },
    disabledButton: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },

    checkboxContainer: {
      display: "flex",
      alignItems: "center",
      borderRadius: "48px",
      padding: "10px 16px",
      justifyContent: "center",
      gap: "10px",
      height: "68px",
    },
    loader: {
      border: "4px solid #f3f3f3",
      borderTop: "4px solid #3498db",
      borderRadius: "50%",
      width: "20px",
      height: "10px",
      animation: "spin 1s linear infinite",
    },
  };

  const formatPhoneNumber = (value: string): string => {
    const cleaned = ("" + value).replace(/\D/g, "");
    if (cleaned.length > 10) {
      setPhoneError("Phone number cannot exceed 10 digits");
      return value;
    } else {
      setPhoneError("");
    }

    if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
        6,
        10
      )}`;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length <= 10) {
      setPhone(formatPhoneNumber(value));
    }
  };

  const stateOptions = {
    AK: "Alaska",
    AL: "Alabama",
    AR: "Arkansas",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming",
  };

  const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedState = e.target.value as keyof typeof stateOptions; // Type assertion

    setState(selectedState);
    localStorage.setItem(
      "state",
      JSON.stringify({ key: "state", value: selectedState })
    );
    localStorage.setItem(
      "fullState",
      JSON.stringify({ key: "fullState", value: stateOptions[selectedState] })
    );
  };

  const inputError = (errorMessage: string) => {
    if (!errorMessage) return null;
    return (
      <div className="checkout-state-error" style={{ marginTop: "20px" }}>
        <img src={Alert} alt="state-error" width={"16px"} height={"15px"} />
        <p className="checkout-state-error-text">{errorMessage}</p>
      </div>
    );
  };

  const handleBack = () => {
    navigate("/getting-started/step-6");
  };


  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container">
        <CustomStepper activeStep={1} onBack={handleBack} />
        <div className="signup-content">
          <p
            className="signup-intro-info signup-intro-info-mobile-text"
            style={{ textAlign: "center" }}
          >
            Amazing! You’ve been pre-approved as an ideal candidate for{" "}
            <span className="signup-intro-special-words signup-intro-info-mobile-text">
              Claya&apos;s GLP-1 wellness
            </span>{" "}
            journey.
          </p>
          <p
            className="signup-intro-para-second signup-intro-para-second-mobile-text"
            style={{ marginBottom: 30, textAlign: "center" }}
          >
            To receive your tailored medication plan and begin your wellness
            journey with Claya, enter the following contact information.
          </p>
          <div className="singup-personal-name">
            <div style={styles.inputContainer}>
              <p
                className="signup-content-heading"
                style={{ marginBottom: "10px", fontSize: "14px" }}
              >
                First Name
              </p>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="First name"
                className="input-fields input-box"
              />
            </div>

            <div style={styles.inputContainer}>
              <p
                className="signup-content-heading"
                style={{ marginBottom: "10px", fontSize: "14px" }}
              >
                Last Name
              </p>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Last name"
                className="input-fields input-box"
              />
            </div>
          </div>

          <div style={styles.inputContainer}>
            <p
              className="signup-content-heading"
              style={{ marginBottom: "10px", fontSize: "14px" }}
            >
              Email
            </p>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError("");
                setErr("");
              }}
              placeholder="Email"
              className="input-fields input-box"
            />
            {emailError && inputError(emailError)}
          </div>

          <div style={styles.inputContainer}>
            <p
              className="signup-content-heading"
              style={{ marginBottom: "10px", fontSize: "14px" }}
            >
              Phone Number
            </p>
            <input
              type="tel"
              value={phone}
              onChange={handleChange}
              placeholder="Phone number: (XXX) XXX-XXXX"
              className="input-fields input-box"
            />
            {phoneError && inputError(phoneError)}
          </div>
          <div className="select-container" style={{ width: "100%" }}>
            <p
              className="signup-content-heading"
              style={{ marginBottom: "10px", fontSize: "14px" }}
            >
              State
            </p>
            <select
              id="state"
              name="state"
              value={state}
              onChange={handleStateChange} // Use the new handler
              className="custom-select"
            >
              <option value={""}>Select a state</option>
              {Object.entries(stateOptions).map(([abbreviation, fullName]) => (
                <option key={abbreviation} value={abbreviation}>
                  {fullName}
                </option>
              ))}
            </select>
          </div>

          <div style={styles.checkboxContainer}>
            <input
              type="checkbox"
              checked={isSubscribed}
              onChange={() => setIsSubscribed(!isSubscribed)}
              style={{ cursor: "pointer" }}
            />
            <label className="checkboxLabel checkbox-label">
              By subscribing, you agree to receive Account Notification text
              messages at the phone number provided. Reply STOP to cancel.
              Message and data rates may apply.
            </label>
          </div>
          {err && inputError(err)}
          <button
            onClick={handleNext}
            disabled={
              !(
                firstName &&
                lastName &&
                email &&
                phone &&
                state &&
                isSubscribed
              ) || loading
            }
            className="next-btn"
            style={{
              backgroundColor:
                loading ||
                !(
                  firstName &&
                  lastName &&
                  email &&
                  phone &&
                  state &&
                  isSubscribed
                )
                  ? "#d3d3d3"
                  : "#0c3972",
            }}
          >
            {loading ? "Loading..." : "Continue →"}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NewSignupPage7;
